// src/App.js
import { useState } from 'react';
import SaveManager from './components/SaveManager';
import BuildPage from './features/build/BuildPage';
import BattlePage from './features/battle/BattlePage';
import './App.css';

export default function App() {
  // state ที่บอกว่าหน้าไหนกำลังแสดง
  const [view, setView] = useState('saves'); // 'saves' | 'build' | 'battle'

  // state สำหรับช่องเซฟที่เลือก (0,1,2)
  const [slotIndex, setSlotIndex] = useState(null);

  // state สำหรับ hero ปัจจุบัน
  const [hero, setHero] = useState(null);

  return (
    <>
      {/* 1️⃣ หน้า Save Manager (เลือกเซฟ) */}
      {view === 'saves' && (
        <SaveManager
          // โหลดเกมจากช่องนั้น
          onLoad={(s, i) => {
            setSlotIndex(i);     // จำช่องที่โหลด
            setHero(s.hero);     // โหลด hero จากเซฟ
            setView('battle');   // ไปหน้า Battle
          }}
          // เริ่มเกมใหม่
          onNew={(i) => {
            setSlotIndex(i);     // จำว่าเป็นช่องนี้
            setHero(null);       // ยังไม่มี hero ใหม่
            setView('build');    // ไปหน้า BuildPage
          }}
        />
      )}

      {/* 2️⃣ หน้า Build (สร้างตัวละครใหม่) */}
      {view === 'build' && (
        <BuildPage
          slotIndex={slotIndex}       // ✅ ส่ง slotIndex ไปให้ BuildPage
          onStart={(h) => {
            setHero(h);               // เก็บ hero ที่เพิ่งสร้าง
            setView('battle');        // ไปหน้า Battle ต่อ
          }}
        />
      )}

      {/* 3️⃣ หน้า Battle */}
      {view === 'battle' && hero && (
        <BattlePage
          slotIndex={slotIndex}       // ✅ ส่ง slotIndex ไปด้วยเพื่อเซฟอัตโนมัติ
          hero={hero}
          setHero={setHero}
          onExit={() => setView('saves')}
        />
      )}
    </>
  );
}
